import Vue from "vue";
import Router from "vue-router";
import fs from "fs";

Vue.use(Router);

const blogPostRoutes = () => {
    //get all the file names of the markdown posts, dont use require.context as this is a module project.
    const markdownFiles = fs.readdirSync("./src/components/Layout/MarkdownBlog/posts/");
    console.log(markdownFiles);
  const files = markdownFiles;
  return files.map((file) => {
    const slug = file.replace("./", "").replace(".md", "");
    return {
      path: `/blog/post/${slug}`,
    }
  })
}

const routes = [
    {
        path: "/",
        name: "home",
        meta: {
            title: "Home",
        },
        component: function () {
            return import(/* webpackChunkName: "about" */ "./views/Home.vue");
        },
    },
    {
        path: "/url",
        name: "urlshort",
        meta: {
            title: "URL Shortener",
        },
        component: function () {
            return import(/* webpackChunkName: "about" */ "./views/URLShort.vue");
        },
    },
    {
        path: "/blog/post/:slug",
        name: "blogpost",
        component: function () {
            return import(
                /* webpackChunkName: "about" */ "./views/MarkdownBlog.vue"
                );
        },
    },
    {
        path: "*",
        component: () => {
            return import(
                /* webpackChunkName: "about" */
                "./views/NotFound.vue"
                );
        },
    },
]

export default new Router({
    mode: "history",
    base: "/",
    routes
});

export const sitemapGenerator = () => {
    const removedDynamicRoutes = routes.filter((route) => {
        return !route.path.includes(":");
    });
    return [...removedDynamicRoutes, ...blogPostRoutes()].map((route) => {
        return {
            url: route.path,
            changefreq: "daily",
            lastmod: new Date().toISOString().split('T')[0],
            priority: 1.0,
        };
    });
}